import React, {ChangeEvent} from 'react';
import {ReactComponent as BasketIcon} from '../../../../../../../assets/main/profile-box/basket.svg';
import {ReactComponent as PhotoIcon} from '../../../../../../../assets/main/profile-box/photo.svg';
import {ReactComponent as KeyIcon} from '../../../../../../../assets/main/profile-box/key.svg';
import {ReactComponent as EditIcon} from '../../../../../../../assets/main/groups/main-top/edit.svg';
import {useAppDispatch, useAppSelector} from "../../../../../../../common/hook";
import {setChangePasswordAC, setEditProfileAC} from "../../../../../../../app/popups-reducer";
import {setAvatar} from "../../../../../../../features/model/slice/avatarSlice";
import {uploadAvatar} from "../../../../../../../features/model/service/avatar/fetchAddAvatar";
import {deleteAvatar} from "../../../../../../../features/model/service/avatar/fetchDeleteAvatar";


export const BoxTeacher = () => {
    const isEditProfile = useAppSelector((state) => state.popups.isEditProfile);
    const isChangePassword = useAppSelector((state) => state.popups.isChangePassword);
    const dispatch = useAppDispatch();
    const data = useAppSelector((state) => state.profile);

    const deleteAvatarHandler = () => {
        dispatch(deleteAvatar());
    }


    const onClickEditHandler = () => {
        dispatch(setEditProfileAC(!isEditProfile));
    };

    const onClickPasswordHandler = () => {
        dispatch(setChangePasswordAC(!isChangePassword));
    };

    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }
        try {
            const resultAction = await dispatch(uploadAvatar(file));
            if (uploadAvatar.fulfilled.match(resultAction)) {
                dispatch(setAvatar(resultAction.payload));
            }
        } catch (error) {
            console.error('Error uploading avatar:', error);
        }
    };

    return (
        <div className="person-data-box">
            <div className="person-data-col">
                <div className="person-avatar-box">
                    <div className="person-avatar avatar">
                        <label htmlFor="avatar-input" className="avatar-input-label">
                            <input
                                type="file"
                                id="avatar-input"
                                accept="image/*"
                                onChange={handleFileChange}
                                style={{display: 'none'}}
                            />
                            {data?.data?.avatar &&
                                <img src={data.data.avatar} alt=""/>
                            }
                            {data?.data?.hasAvatar ?
                                <button className="action-btn" onClick={deleteAvatarHandler}>
                                    <BasketIcon/>
                                </button>
                                : <span className="action-btn"><PhotoIcon/></span>}
                        </label>
                    </div>
                </div>
                <div className="person-data data_person">
                    <p className="h3 person-name">{data?.data?.fullName}</p>
                    <div className='person-data-pesonal'>
                        <p className="sub-text">{data?.data?.roleName}</p>
                        {data?.data?.company &&
                            <>
                                <p className="sub-text">/</p>
                                <p className="sub-text">{data?.data?.company}</p>
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className="person-controls-col">
                <p className="p-icon control-btn pointer-elem" onClick={onClickEditHandler}>
                    Редактировать профиль{' '}
                    <span className="icon">
                        <EditIcon/>
                    </span>
                </p>
                <p className="p-icon control-btn pointer-elem" onClick={onClickPasswordHandler}>
                    Сменить пароль
                    <span className="icon">
                        <KeyIcon/>
                    </span>
                </p>
            </div>
        </div>
    );
};
